// audit-kinds.ts — numeric ordinal → human-readable label mapping.
// Mirrors keyforge/src/kf_audit_types.sk §1 (kind ordinals)
// and §2 (outcome ordinals). Keep in sync when new ordinals ship.

export const AUDIT_KIND: Record<number, string> = {
  0: 'unknown',

  // Auth surface
  1: 'login.ok',
  2: 'login.fail',
  3: 'token.issued',
  4: 'token.verify.fail',
  5: 'password.changed',

  // Tenant surface
  10: 'tenant.created',
  11: 'tenant.updated',
  12: 'tenant.deleted',

  // Subscription surface
  20: 'subscription.created',
  21: 'subscription.updated',
  22: 'subscription.cancelled',

  // Node + license
  30: 'node.enrolled',
  31: 'license.issued',
  32: 'license.revoked',

  // RBAC
  40: 'rbac.denied',
};

export const AUDIT_OUTCOME: Record<number, string> = {
  0: 'ok',
  1: 'denied',
  2: 'error',
  3: 'invalid',
};

export function auditKindLabel(k: number): string {
  return AUDIT_KIND[k] ?? `kind:${k}`;
}

export function auditOutcomeLabel(o: number): string {
  return AUDIT_OUTCOME[o] ?? `outcome:${o}`;
}

export function auditOutcomeCssClass(o: number): 'ok' | 'err' {
  return o === 0 ? 'ok' : 'err';
}
